export default __webpack_public_path__ + "static/media/default_avatar_square.a49ae53a.svg";